export default __webpack_public_path__ + "static/media/moveIcon.b6050741.svg";